import { getAdminUsers } from 'requests/invite';
import { AdminUser } from 'data/BusinessUnitUser';
import { useUserProfiles } from './useUserProfiles';

interface UseAdminUsersProps {
    reload?: boolean;
    setReload?: (reload: boolean) => void;
}

/**
 * Hook for managing admin users (Admin, SuperAdmin, VendorAdmin)
 * Uses the generic useUserProfiles hook with admin-specific configuration
 */
export const useAdminUsers = ({
    reload,
    setReload
}: UseAdminUsersProps) => {
    return useUserProfiles<AdminUser>({
        fetchFunction: getAdminUsers,
        buildParams: ({ currentPage, rowsPerPage, sortBy, sortOrder, searchTerm }) => [
            currentPage + 1, // API expects 1-based page
            rowsPerPage,
            sortBy,
            sortOrder,
            searchTerm
        ],
        reload,
        setReload,
        successMessages: {
            delete: 'Admin removed successfully',
            bulkDelete: 'Admin(s) removed successfully'
        }
    });
};
